export default __webpack_public_path__ + "static/wizard-purple-192-1949b56558bef4739939607d47ff4c39.png";